import {css} from 'lit';
export const styles = css`.section-group{display:flex;flex-direction:column;gap:.5rem}::slotted(atlas-section){margin-bottom:0}`;
export default styles;
